import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AdminCoupons() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ code: "", percent_off: 10, active: true });
  const load = () => api.get("/admin/coupons").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/coupons", { ...form, code: form.code.toUpperCase(), percent_off: parseFloat(form.percent_off) }); toast.success("Coupon created"); setForm({ code: "", percent_off: 10, active: true }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { await api.delete(`/admin/coupons/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-coupons-page">
      <div className="eyebrow mb-2">Discounts</div>
      <h1 className="aperture-h1 text-4xl mb-10">Coupons.</h1>

      <form onSubmit={create} className="bg-white p-6 rounded-sm border mb-8 flex gap-3 items-end" style={{ borderColor: "rgba(10,37,64,0.10)" }} data-testid="coupon-form">
        <div className="flex-1"><label className="eyebrow block mb-2">Code</label><input required value={form.code} onChange={(e)=>setForm({...form, code:e.target.value})} data-testid="coupon-code" className="w-full px-4 py-2.5 border rounded-sm text-sm focus:outline-none focus:border-gold" style={{ borderColor: "rgba(10,37,64,0.15)" }} /></div>
        <div><label className="eyebrow block mb-2">Percent Off</label><input required type="number" min="1" max="100" value={form.percent_off} onChange={(e)=>setForm({...form, percent_off:e.target.value})} data-testid="coupon-percent" className="w-24 px-4 py-2.5 border rounded-sm text-sm focus:outline-none focus:border-gold" style={{ borderColor: "rgba(10,37,64,0.15)" }} /></div>
        <button data-testid="coupon-create" className="btn-primary px-5 py-2.5 text-xs uppercase tracking-widest inline-flex items-center gap-2 rounded-sm"><Plus className="w-3.5 h-3.5"/>Create</button>
      </form>

      <div className="bg-white rounded-sm border" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Code","Percent Off","Active","Actions"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan="4" className="px-4 py-10 text-center text-navy/50">No coupons.</td></tr>}
            {list.map((c) => (
              <tr key={c.id} className="border-t" style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3 font-mono">{c.code}</td>
                <td className="px-4 py-3">{c.percent_off}%</td>
                <td className="px-4 py-3">{c.active ? "✓" : "—"}</td>
                <td className="px-4 py-3"><button onClick={()=>del(c.id)} className="text-red-600 hover:text-red-800 inline-flex items-center gap-1 text-xs"><Trash2 className="w-3 h-3"/>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
